































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Plant from "@/domainObjects/Plant";
import WipTicket from "@/domainObjects/wip/WipTicket";
import {mapGetters} from "vuex";
import TicketService from "@/services/TicketService";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";

@Component({
    name: 'WipTicketTable',
    components: {LoadingIndicator},
    computed: {
        ...mapGetters(['getGroups']),
    }
})
export default class WipTicketTable extends Vue {
    @Prop({required: false}) searchJSON!: string;

    private wipTickets:WipTicket[] = []
    private fields:Fields[] = [];
    private currentPage:number = 0;
    private perPage:number = 0;
    private totalRows:number = 0;
    private filter:string = '';
    private hover:boolean = true;
    private pageOptions:number[] = [];
    private sortBy:string = '';
    private sortDesc:boolean = true;
    private busy: boolean = false;
    private tableLayout: boolean = false;
    private unsecureServerUrl: string;
    private error: boolean = false;
    private windowWidth: number = 0;
    private downloading: boolean = false;

    @Watch('searchJSON', { immediate: true })
    onPropertyChanged(newvalue: string, oldvalue: string){
        if (newvalue){
            this.fetchWipTicketsBySearch();
        }
        if (newvalue == undefined && oldvalue == undefined){
            this.$router.push('/search-wip-ticket')
        }
    }

    constructor() {
        super();
        this.fields = [
            { key: 'wipTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc' },
            { key: 'materialDesc', label: 'Material Desc.', sortable: true, sortDirection: 'desc' },
            { key: 'materialNum', label: 'Material No.', sortable: true, sortDirection: 'desc' },
            { key: 'salesOrderNum', label: 'Sales Order Number', sortable: true, sortDirection: 'desc' },
            { key: 'discrepancy.desc', label: 'Reason Code', sortable: true, sortDirection: 'desc' },
            { key: 'comments', label: 'Desc. of Non-conf', sortable: true, sortDirection: 'desc' },
            { key: 'closedDate', label: 'Date Closed', sortable: true, sortDirection: 'desc' },
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
            { key: 'actions', label: 'Options', sortable: false, sortDirection: '' }
        ];
        this.currentPage = 1;
        this.perPage = 25;
        this.totalRows = this.wipTickets.length;
        this.filter = "";
        this.hover = true;
        this.pageOptions = [ 5, 10, 25, 50, 100 ];
        this.sortBy = 'wipTicketId';
        this.sortDesc = true;
        this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
    }

    fetchWipTicketsBySearch(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.error = false;
        this.busy = true;
        this.wipTickets = [];
        TicketService.getWipTicketsBySearch(this.searchJSON).then((response) => {
            if (response.status != 200){
                this.error = true;
                this.busy = false;
            } else {
                for ( let readWipTicket of response.data ) {
                    let ticket = new WipTicket();
                    ticket.initFromObject(readWipTicket);
                    this.wipTickets.push(ticket);
                }
                this.busy = false;
            }
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

            this.$router.push('/search-wip-ticket')
        });
    }

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    destroyed(){
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.tableLayout = window.innerWidth < 992;
        this.windowWidth = window.innerWidth;
    }

    onFiltered( filteredItems ) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    }

    toggleBusy() {
        this.busy = !this.busy;
    }

    changeLayout(){
        this.tableLayout = !this.tableLayout;
    }

    openCsvFile(result, csvFileName){
        if (window.navigator.msSaveBlob) {
            //Internet Explorer
            window.navigator.msSaveBlob(new Blob([result]), csvFileName);
            // @ts-ignore
        } else if (window.webkitURL != null) {
            //Google Chrome and Mozilla Firefox
            let a = document.createElement("a");
            result = encodeURIComponent(result);
            a.href = "data:application/csv;charset=UTF-8," + result;
            a.download = csvFileName;
            a.click();
        } else {
            //Everything Else
            window.open(result);
        }
    }

    generateWipExcelReport(){
        this.downloading = true;
        TicketService.generateWipExcelReport(this.searchJSON).then((response)=>{
            this.openCsvFile(response.data, "WipTicketSearchResults.csv");
            this.downloading = false;
        }).catch((error) => {

            this.$router.push('/search-wip-ticket')
            alert('error downloading excel file, search criteria may be malformed');
        });
    }

    view(ticketId){
        let routeData = this.$router.resolve({name: 'routeName', params: { wipTicketId: ticketId }})
        window.open(routeData.href, '_blank')
    }

}

